import React from 'react';
import { motion } from 'framer-motion';
interface SectionWrapperProps {
  id: string;
  children: React.ReactNode;
  className?: string;
}
export function SectionWrapper({
  id,
  children,
  className = ''
}: SectionWrapperProps) {
  return <motion.section id={id} className={`py-16 md:py-24 scroll-mt-16 md:scroll-mt-0 ${className}`} initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.7,
    ease: 'easeOut'
  }} data-id="element-191">
      {children}
    </motion.section>;
}